export default __webpack_public_path__ + "static/media/s2.e2f6c098.png";